module.exports = __webpack_public_path__ + "static/2front-hasta-2-4a0fb80dd108b3d7adf86aac2734f837.png";